import { PRICING_PLANS } from "features/subscriptions/constants";

import ProfileImage from "common/components/ui/ProfileImage";
import type { WorkspaceAccount } from "common/types";

import type { ComponentProps, FunctionComponent, SVGProps } from "react";

interface AccountProfileImageProps {
  account: WorkspaceAccount;
  size?: ComponentProps<typeof ProfileImage>["size"];
}

export default function AccountProfileImage({
  account,
  size = "md",
}: AccountProfileImageProps) {
  const {
    license,
    picture_url: pictureUrl,
    full_name: fullName,
    type,
  } = account;

  let Icon: FunctionComponent<SVGProps<SVGSVGElement>>;

  if (type === "rental") {
    Icon = PRICING_PLANS.rental.outlineIcon;
  } else if (license) {
    const { source } = license;
    if (source === "aimfox") {
      Icon = PRICING_PLANS.user.outlineIcon;
    } else if (source === "agency") {
      Icon = PRICING_PLANS.agency.outlineIcon;
    }
  }
  const profileImageComponent = (
    <ProfileImage
      src={pictureUrl}
      aria-label="Account profile image"
      size={size}
      alt={fullName}
    />
  );

  if (Icon) {
    return (
      <div className="shrink-0 relative">
        {profileImageComponent}{" "}
        <Icon className="-right-1 -bottom-1 absolute size-5" />
      </div>
    );
  }
  return profileImageComponent;
}
